const history = {
  title: 'Projelerim',
  upgradeBtn: 'Yükseltme',
  subTitle: 'Dosyanızı 72 saat sonra silineceği için indirmeyi unutmayınız.',
  MAgo: '{{num}} dakika önce',
  HAgo: '{{num}} saat önce',
  DAgo: '{{num}} saat önce',
  justNow: 'Şu anda',
  originalFile: 'Orijinal dosya',
  selectAllBtn: 'Tümünü seç',
  emptyTips: 'Henüz proje yok. <1>Git düzenle</1>',
  deleteTips: 'Silmek istediğinizden emin misiniz?',
};

export default history;
